import { render, staticRenderFns } from "./NotificationSettingMobile.vue?vue&type=template&id=c5fd0ada&scoped=true&"
import script from "./NotificationSettingMobile.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingMobile.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSettingMobile.vue?vue&type=style&index=0&id=c5fd0ada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fd0ada",
  null
  
)

export default component.exports